module.exports = __webpack_public_path__ + "img/login-calacali.9c78f3c5.svg";